<template>
  <div class="technicist home-module">
    <div class="container">
      <tgo-title :title="title" :special="'special'" :subtitle="subtitle" class="technicist-title"></tgo-title>
      <ul class="head-list">
        <li :class="{'active': introShowIndex === i}" class="item" v-for="(item, i) in headLists" :key="i"  @mouseover="introShow(i)" @mouseout="introHidden">
          <div class="img-wrap">
            <div class="img"
              :style="{'background-image': `url(${item.img})`}"
            >
            </div>
          </div>
          <div class="head-name">{{item.name}}</div>
          <div class="head-title">{{item.title}}</div>
          <div v-if="item.intro" class="sign"></div>
          <div v-if="!isMobile && item.intro" class="item-intro" :style="{transform: `translateX(-${(i < headLen ? i % 5 * 234 : i % 5 * 234 + 100)}px)`}">
            <p class="intro-text">{{item.intro}}</p>
          </div>
          <div v-if="isMobile && item.intro" class="item-intro" :style="{transform: `translateX(-${((i % 2) === 0 ? 3.5 : 47)}vw)`}">
            <p class="intro-text">{{item.intro}}</p>
          </div>
        </li>
      </ul>
      <!-- <a href="/join" class="mobile-technicist-button" v-if="isMobile">
        加入 TGO
      </a> -->

    </div>
    <!-- <img src="./assets/technicist.png" alt="" v-if="!isMobile"> -->
    <div class="join-btn">
      <router-link to="/join" target="_blank">
        <tgoButton :use="isMobile ? 'mobile bg' : 'bg'">立即申请加入TGO</tgoButton>
      </router-link>
    </div>
  </div>
</template>
<script>
import tgoTitle from '@/base/ego-title'
import tgoButton from '@/base/ego-button-new'
export default {
  data () {
    return {
      introShowIndex: null,
      headLists: [
        {
          name: '伍涛',
          title: 'Funplus Co-CTO',
          img: require('../../../assets/img/wutao.png'),
          intro: '我加入TGO已经三年多，推荐了很多人，现在也担任了TGO上海的负责人，我很喜欢TGO的氛围，我希望更多技术圈的朋友们加入进来。TGO是技术人学习成长的深度社交圈子，在这里，我们可以开拓技术视野，拓展人脉资源，体验“叠加人生”。无论哪个技术方向，TGO都有大牛；走到哪里，都有亲切的学员朋友，TGO已覆盖全球12个城市。时代进步，技术发挥作用会更大，TGO是技术人的大家庭，这是一个有营养、有温度的组织，技术让社会变得更美好，TGO让技术人变得更美好。'
        },
        {
          name: '陆栋栋',
          title: '喜马拉雅 CTO',
          img: require('../../../assets/img/ludongdong.png'),
          intro: '2016年底，当时喜马拉雅处于高速发展期，自己也刚从程序员成长出来，在很多方面都没有经验，这时恰逢TGO出现，给了我向行业向各位老师学习的机会。TGO 鲲鹏会为所有企业提供了非常好的交流学习平台，不同行业的不同业态，不同领域的不同技术解决方案，不同人的不同经验知识，不同阶段的不同组织形态，不同企业的不同商业模式等。在宽度上给我有更多的视野，在深度上又给我向前行的提示。'
        },
        {
          name: '丁宁',
          title: '荔枝 CTO',
          img: require('../../../assets/img/dingning.jpg'),
          intro: '我是TGO广州地区的创始学员，从我加入TGO的第一天起我就深信她能给我带来巨大的价值。将近4年的时间里我认识了来自各个领域的众多技术人，拜访了不同的知名企业倾听分享讨论主题，不论成功还是失败案例都促使我不断的思考和行动，不同的企业文化和价值观又给我带来了新的冲击感。这些提升使我站在更高的视角来看待技术、管理与业务，重新拓展了我的视野边界。希望在今后的日子里TGO越办越好，让我们所有的学员能够一起成长一起进步。'
        },
        {
          name: '胡哲人',
          title: '流利说 CTO',
          img: require('../../../assets/img/huzheren.png'),
          intro: '最早知道 TGO 是通过 QCon，在我们创业的初期，QCon 提供了一个很好的平台让我们可以和业内其他技术团队去分享一些在技术和管理上的实践。加入了 TGO这几年，一方面我通过线下小组这样的形式和其他学员有了深入的交流，特别是从小组里更资深的成员身上学到了不少东西；同时随着我们公司本身的成长，TGO 也提供了让我把自己的一些沉淀分享给大家，并且得到更多反馈的舞台。TGO 的成员因为技术而聚在一起的，但交流的话题远不止于技术，大家互相学习，共同成长。'
        },
        {
          name: '郭炜',
          title: '前易观 CTO',
          img: require('../../../assets/img/guowei.png'),
          intro: '每一个CTO都是孤独的，因为有太多的事情你不能和你的合伙人来讲，也不能和CEO来说，更不能和下属来讲。TGO给我们了一个空间来深度交流。在这里，你遇到了很多同道中人，可以深度分享他和你的人生、管理想法，扩展你的认知。例如，在易观技术整体架构从整体单一汇报线到“一横N纵”汇报线变化时，我过去没有经历过，小组的成员给了我很大的启发和信心，最终完成公司技术架构的变革。TGO还会全面培养你成为科技领导人的知识，例如，投资人的技能、演讲的技能，甚至是身体健康和品酒的知识，让一个CTO超越自己的能力门槛。最近的TGO Talk训练，就颠覆了我过去所有以往所有演讲的认知，重新认识了18分钟TED演讲背后的意义。总之，TGO是一个讲究奉献和分享、帮助CTO突破自我的社区，值得每一个CTO都深度参与。'
        },
        {
          name: '黄东旭',
          title: 'PingCAP/TiDB CTO',
          img: require('../../../assets/img/huangdongxu.png'),
          intro: '我记得在加入 TGO （当年还叫 EGO）之前，甚至在 TGO 成立之前，我就特别希望能有一个平台能够和背景相似的技术人互相交流，另外 TGO 成立的时候，我们刚好是刚出来创业，也可以说 TGO 和 PingCAP / TiDB 是一同成长起来的，因为自己的技术背景，以及也是做2B创业的，TGO 的学员朋友们（特别是我们组长老杨）给了我很多宝贵的建议，从过来人的角度帮我分析问题，甚至帮忙连接资源。我觉得 TGO 最大的意义在于让技术人之间能够有一个很「安心」，很「舒服」的沟通平台，大家说着一样的语言，有着一样的价值观，有一种「自己人」的感觉。'
        },
        {
          name: '韩卿',
          title: 'Kyligence CEO',
          img: require('../../../assets/img/hanqing.png'),
          intro: '在创业和个人成长方面，TGO给了我很多力量，这力量来自于一群真诚的技术朋友，他们都有着用技术改变世界的梦想。但现实中，技术人如何在商业社会中找到自我价值的实现、如何组队打怪、如何处理棘手的情形、如何突破自我的认知……其实是非常难的问题。因此，没有比TGO更好的组织，在这些问题上，感谢帮助过我、给我过无数建议和真知的组织内的同学们，感谢TGO！'
        },
        {
          name: '杨冀龙',
          title: '知道创宇 CTO',
          img: require('../../../assets/img/yangjilong.jpg'),
          intro: ''
        },
        {
          name: '洪小军',
          title: 'AfterShip CTO',
          img: require('../../../assets/img/hongxiaojun.png'),
          intro: '很开心作为创始成员和负责人一起推动TGO厦门的成立，同时，因为TGO厦门的成立，也让厦门地区的主要技术负责人能更好地连接起来。之前少有机会能把这么多这么齐的技术负责人聚在一起，随着聚集的人越来越多，也会有更多的火花碰撞，也产生了非常多的连接，对于厦门地区整体技术氛围的提升起到了重要作用。由于工作调动关系，2019年年中我离开厦门到深圳创业，那TGO深圳也帮我更好地连接深圳的资源，让我和深圳当地的技术管理者们产生了更多的碰撞，一起交流一起成长。'
        }
      ]
    }
  },
  components: {
    tgoTitle,
    tgoButton
  },
  props: ['isMobile'],
  computed: {
    headLen () {
      return Math.floor(this.headLists.length / 5) * 5
    },
    title () {
      return '大咖集结，因聚而变'
    },
    subtitle () {
      if (this.isMobile) {
        return '汇聚 <span style="font-size:18px;color: #D7B375;font-weight: 500">1700+</span> 科技领导者，沉淀人脉资源，提升自身职业价值，洞悉技术发展趋势'
      } else {
        return '汇聚 <span style="font-size:24px;color: #D7B375;font-weight: 500">1700+</span> 科技领导者，沉淀人脉资源，提升自身职业价值，洞悉技术发展趋势'
      }
    },
    button () {
      return '加入 TGO'
    }
  },
  methods: {
    introShow (index) {
      this.introShowIndex = index
    },
    introHidden () {
      this.introShowIndex = null
    },
    clickBtn () { if (window.ga) window.ga('send', 'event', '页面点击', '首页-大咖集结') }
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
@import '../../../style/bulma/app.sass';

.technicist {
  position: relative;
  overflow: hidden;
  background-image: url('../../../assets/img/technicist-bg.png');
  background-size: 100% auto;
  background-position: left top;
  background-color: rgba(245, 245, 245, 1);

  @include mobile {
    background-image: url('../../../assets/img/technicist-m-bg.png');
    background-size: contain;
  }

  & .container {
    width: calc(100vw - 90px);
  }

  & .head-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 60px;
    margin-bottom: 10px;

    @include mobile {
      margin-top: 30px;
      margin-left: auto;
      margin-right: auto;
      max-width: 285px;
      justify-content: flex-start;
    }

    & .item {
      position: relative;
      width: 134px;
      margin-right: 100px;
      margin-bottom: 50px;
      text-align: center;
      cursor: pointer;
      .item-intro {
        position: relative;
        display: flex;
        align-items: center;
        width: 1080px;
        height: 0px;
        opacity: 0;
        overflow: hidden;
        transition: all 0.6s ease;
        box-sizing: border-box;
        margin-top: 35px;
        border-top: 2px solid rgba(215,179,117,0.5);
        border-bottom: 2px solid rgba(215,179,117,0.5);
        &::before {
          content: "";
          position: absolute;
          left: 15px;
          top: 20px;
          width: 34px;
          height: 34px;
          background: url('../../../assets/img/quotes.png') no-repeat center / cover;
          @include mobile {
            left: 0;
            width: 18px;
            height: 18px;
            background-size: 100% 100%;
          }
        }
        &::after {
          content: "";
          position: absolute;
          right: 15px;
          bottom: 20px;
          width: 34px;
          height: 34px;
          transform: rotate(180deg);
          background: url('../../../assets/img/quotes.png') no-repeat center / cover;
          @include mobile {
            right: 0px;
            width: 18px;
            height: 18px;
            background-size: 100% 100%;
          }
        }
        .intro-text {
          text-align: justify;
          padding: 0 66px;
          @include mobile {
            padding: 5vw 7vw;
          }
        }
        @include mobile {
          display: none;
          width: 78vw;
          opacity: 1;
        }
      }
      &.active {
        .item-intro {
          opacity: 1;
          height: 180px;
          @include mobile {
            display: block;
            height: auto;
          }
        }
        .sign {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          overflow: hidden;
          margin-top: 20px;
          background: url('../../../assets/img/pointed.png') no-repeat center / cover;
          z-index: 10;
          padding-bottom: 20px;
        }
      }

      &:nth-child(5) {
        margin-right: 0;
      }

      &:nth-child(6) {
        margin-left: 98px;
      }

      @include mobile {
        width: 106px;
        margin: 0;
        margin-right: 0;
        margin-bottom: 20px;

        &:nth-child(2n) {
          margin-left: auto;
        }

        &:nth-child(5) {
          margin-right: 0 ;
        }

      }

      & .img-wrap {
        margin-bottom: 15px;
        width: 100%; height: 134px;
        border: 1px solid  $primary3;
        border-radius: 50%;

        @include mobile {
          height: 106px;
        }
        & .img {
          padding: 4px;
          width: 100%; height: 100%;
          border: 4px solid #fff;
          border-radius: 50%;
          background-size: 100%;
        }
      }

      & .head-name {
        margin-bottom: 14px;
        font-size: 20px;
        font-weight: 500;
        line-height: 1;
      }

      & .head-title {
        width: 110%;
        margin-left: -5%;
        font-size: 16px;
        line-height: 1;
      }
    }
  }

  & .join-btn {
    margin: 0 auto;
    width: 350px;

    @include mobile {
      width: 86%;
      max-width: 306px;
    }
  }
}
</style>
